import React from "react";
import { Star } from "lucide-react";
import { SITE } from "@/data/site";

export default function Reviews() {
  // Duplicate for seamless marquee
  const items = [...SITE.reviews, ...SITE.reviews];

  return (
    <section
      id="reviews"
      data-testid="reviews-section"
      className="relative bg-brand-bg py-24 lg:py-32 border-t border-brand-border overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-14">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div>
            <div className="text-xs uppercase tracking-[0.3em] text-brand-accent">
              Recenze z Google
            </div>
            <h2 className="mt-4 font-display font-black text-4xl lg:text-6xl leading-tight tracking-tight">
              Slova,{" "}
              <span className="italic font-light">která nás drží</span> ráno na nohou.
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <div className="flex items-center gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} size={18} className="fill-brand-accent text-brand-accent" />
              ))}
            </div>
            <div>
              <div className="font-display font-bold text-xl">4.9 / 5</div>
              <div className="text-xs text-brand-muted">Car Spa Čestlice</div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee row */}
      <div className="relative">
        <div className="flex gap-6 w-max animate-marquee">
          {items.map((r, idx) => (
            <article
              key={idx}
              data-testid={`review-card-${idx}`}
              className="w-[340px] sm:w-[420px] shrink-0 bg-brand-surface border border-brand-border p-8 flex flex-col"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} size={14} className="fill-brand-accent text-brand-accent" />
                ))}
              </div>
              <p className="text-white/90 text-sm leading-relaxed">&ldquo;{r.text}&rdquo;</p>
              <div className="mt-6 pt-6 border-t border-brand-border flex items-center justify-between">
                <div>
                  <div className="font-display font-bold">{r.name}</div>
                  <div className="text-xs text-brand-muted">Ověřená recenze</div>
                </div>
                <div className="text-xs text-brand-accent uppercase tracking-[0.2em]">
                  {r.source}
                </div>
              </div>
            </article>
          ))}
        </div>
        {/* fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-brand-bg to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-brand-bg to-transparent" />
      </div>
    </section>
  );
}
